import * as actionTypes from '@store/actions/actionTypes'
import defaultTheme from '@themes'

const innerWidth = typeof window === 'object' ? window.innerWidth : null
const innerHeight = typeof window === 'object' ? window.innerHeight : null
const maxRouteStack = 5

const initialState = {
  innerWidth,
  innerHeight,
  snackbar: null,
  theme: defaultTheme,
  processing: false,
  responseStatus: null,
  snackbarMessage: '',
  mobileDrawerOpen: false,
  history: [],
  userTab: null,
  typeAheadNoContactsFound: false,
  printPane: false,
  nameForDocumentTitle: '',
  haveZipOnTaxDetail: null,
  previousRoutes: [],
  propertyActionsSheet: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SCREEN_RESIZE:
      return {
        ...state,
        innerWidth: action.width,
        innerHeight: action.height
      }
    case actionTypes.SHOW_SNACKBAR:
      return {
        ...state,
        snackbarMessage: action.message
      }
    case actionTypes.EXPAND_CARD:
      return {
        ...state,
        expandedCard: action.previewId
      }
    case actionTypes.SET_THEME:
      return {
        ...state,
        theme: action.theme
      }
    case actionTypes.SET_PROCESSING:
      return {
        ...state,
        processing: action.bool
      }
    case actionTypes.TOGGLE_MOBILE_NAV_DRAWER:
      return {
        ...state,
        mobileDrawerOpen: action.bool
      }
    case actionTypes.ADD_HISTORY:
      return {
        ...state,
        history: [...state.history, action.obj]
      }
    case actionTypes.SET_HISTORY_CURSOR:
      return {
        ...state,
        historyCursor: action.cursor
      }
    case actionTypes.UPDATE_HISTORY_WITH_LABEL:
      return {
        ...state,
        history: state.history.map(h => {
          if (
            h.path === action.path &&
            (!action.search || action.search === h.search)
          ) {
            return {
              ...h,
              title: action.title,
              subtitle: action.subtitle
            }
          }
          return h
        })
      }
    case actionTypes.SLICE_HISTORY_AT_CURSOR:
      return {
        ...state,
        history: [...state.history]
          .reverse()
          .slice(state.historyCursor)
          .reverse(),
        historyCursor: 0
      }
    case actionTypes.REMOVE_LAST_HISTORY_ITEM:
      return {
        ...state,
        history: state.history.length ? state.history.slice(0, -1) : []
      }
    case actionTypes.SET_USER_TAB:
      return {
        ...state,
        userTab: action.tab
      }
    case actionTypes.SET_TYPEAHEAD_NO_CONTACTS_FOUND:
      return {
        ...state,
        typeAheadNoContactsFound: action.bool
      }
    case actionTypes.TOGGLE_PRINT_PANE:
      return {
        ...state,
        printPane: action.bool
      }
    case actionTypes.SET_NAME_FOR_DOCUMENT_TITLE:
      return {
        ...state,
        nameForDocumentTitle: action.name
      }
    case actionTypes.TRIGGER_SUBSCRIBER_WELCOME_MODAL:
      return {
        ...state,
        triggerWelcomeModal: action.bool
      }
    case actionTypes.SET_BLADE_EXPANDED:
      return {
        ...state,
        bladeExpanded: action.id
      }
    case actionTypes.SET_HAVE_ZIP_ON_TAX_DETAIL:
      return {
        ...state,
        haveZipOnTaxDetail: action.bool
      }
    case actionTypes.SHOW_PROPERTY_ACTIONS_SHEET:
      return {
        ...state,
        propertyActionsSheet: action.property
      }
    case actionTypes.HIDE_PROPERTY_ACTIONS_SHEET:
      return {
        ...state,
        propertyActionsSheet: null
      }
    case 'PUSH_ROUTE': {
      const newStack = [...state.previousRoutes, action.route]
      return {
        ...state,
        previousRoutes:
          newStack.length > maxRouteStack
            ? newStack.slice(newStack.length - maxRouteStack)
            : newStack
      }
    }
    default:
      return state
  }
}

export default reducer
